<template>
  <div class="tariff-entry ver-2">
    <div class="flex flex-col gap-3">
      <div class="image">
        <a :name="entry.tariffId"/>
        <img class="w-full rounded-3xl sm:hidden" :src="entry.imageUrlMobile || entry.imageUrl" :alt="entry.title">
        <img class="w-full rounded-3xl hidden sm:block" :src="entry.imageUrl" :alt="entry.title">
      </div>
      <div class="date-range">
        Aktionszeitraum: <br>
        {{ getDateFormated(new Date(entry.validFrom)) }} -
        {{ getDateFormated(new Date(entry.validTo)) }}
      </div>
      <div class="title">{{ entry.title }}</div>
      <div class="id">Tarif ID: {{ entry.tariffId }}</div>
      <div class="short-description" v-html="entry.highlights" />
      <div class="link text-sm text-primary">
        <NuxtLink
          v-if="entry.redirectUrl && entry.redirectUrl.trim() != ''"
          :to="entry.redirectUrl"
          :external="true"
          >Zum Artikel ohne Tarifoption</NuxtLink
        >
      </div>
      <template v-if="linkPath != ''">
        <NuxtLink :to="linkPath + '#' + entry.tariffId" :external="true">
          <button class="cursor-pointer btn-primary px-8 py-3 font-bold mt-4 text-center">
            {{linkText}}
          </button>
        </NuxtLink>
      </template>
      <template v-else>
        <div v-if="currentStore && currentStore.id != 'e_2879130'" class="cta">
          <button
            class="cursor-pointer btn-primary px-8 py-3 font-bold mt-4 text-center"
            @click="showForm = true"
          >
            Kontakt aufnehmen
          </button>
        </div>
      </template>
      <template v-if="entry.legalText.length > 250">
        <div v-if="!showFullLegalText" class="legal-text text-xs relative">
          * {{ entry.legalText.substring(0, 250) }}
          <div class="font-bold cursor-pointer" @click="showFullLegalText = true">
            ... mehr
          </div>
        </div>
        <div v-if="showFullLegalText" class="legal-text text-xs">
          * {{ entry.legalText }}
          <div class="font-bold cursor-pointer" @click="showFullLegalText = false">
            weniger
          </div>
        </div>
      </template>
      <template v-else>
        <div class="legal-text text-xs">* {{ entry.legalText }}</div>
      </template>
    </div>
    <client-only>
      <teleport to="#modals">
        <BasicModal v-if="showForm" class="md p-2 round" @close-modal="showForm = false">
          <template #icon>
            <BasicIcon :name="'xmark-solid'" class="w-4 close-img" />
          </template>
          <form
            class="p-4 flex flex-col gap-3 tarif-submission"
            @submit.prevent="validateForm($event)"
          >
            <div class="text-2xl text-primary font-bold">Jetzt Angebot anfragen</div>
            <div>
              Frage jetzt das Angebot von deinem gewünschten Vertrag an. Fülle ganz
              einfach das Kontaktformular aus und schicke deine Anfrage ab!
            </div>
            <div class="flex flex-col lg:grid lg:grid-cols-3 gap-4 text-sm">
              <div>
                <label for="tarifId">Tarif-ID*</label>
                <div>
                  <input
                    id="tarifId"
                    type="text"
                    name="tarifId"
                    readonly="true"
                    :value="entry.tariffId"
                    class="text-paragraph-light inp sm bg-secondary pointer-events-none"
                  >
                </div>
              </div>
              <div>
                <label for="validFrom">Bevorzugter Kontaktzeitpunkt</label>
                <div>
                  <input
                    id="validFrom"
                    type="datetime-local"
                    class="text-paragraph-light inp sm"
                  >
                </div>
              </div>
              <div class="hidden lg:block" />
              <div>
                <label for="name">Name, Vorname</label>
                <div>
                  <input
                    id="name"
                    type="text"
                    placeholder="Name, Vorname"
                    class="text-paragraph-light inp sm"
                  >
                </div>
              </div>
              <div>
                <label for="email">E-Mail*</label>
                <div>
                  <input
                    id="email"
                    required
                    type="email"
                    placeholder="E-Mail"
                    class="text-paragraph-light inp sm"
                  >
                </div>
              </div>
              <div>
                <label for="phone">Telefon*</label>
                <div>
                  <input
                    id="phone"
                    required
                    name="phone"
                    type="tel"
                    placeholder="Telefon"
                    class="text-paragraph-light inp sm"
                  >
                </div>
              </div>
              <div class="col-span-3">
                <label for="message">Nachricht</label>
                <div>
                  <textarea
                    id="message"
                    class="w-full resize-none border p-2 rounded-sm"
                    name="message"
                    rows="6"
                    placeholder="Hier Nachricht eingeben"
                  />
                </div>
              </div>
            </div>
            <div>
              <NuxtTurnstile
                ref="turnstile"
                v-model="token"
                class="cf-turnstile"
                :options="{ theme: 'light', language: 'de-de' }"
              />
              <div
                v-if="captchaError"
                class="captcha-error-message text-error border-b text-xs"
              >
                Bitte lösen Sie das Captcha
              </div>
              <div v-if="uniqueEmailError" class="text-error border-b text-xs">
                Diese E-Mail hat bereits am Gewinnspiel teilgenommen
              </div>
            </div>
            <label for="consent" class="text-xs flex items-start gap-2">
              <div>
                <input
                  id="consent"
                  v-model="consent"
                  type="checkbox"
                  class="h-4"
                  name="user-consent"
                  required
                >
              </div>
              <div>
                Mit dem Fortfahren erkläre ich mich mit den
                <NuxtLink
                  class="text-primary font-bold"
                  :external="true"
                  target="_blank"
                  :to="
                    'https://www.expert.de/' +
                    currentStore.storeLink +
                    '/Footer/Website/Datenschutzerklaerung'
                  "
                >
                  Datenschutzbestimmungen</NuxtLink
                >
                sowie der Nutzung der Daten durch den ausführenden Fachmarkt
                einverstanden.
              </div>
            </label>
            <div>
              <button class="btn-primary px-12 text-sm font-bold w-full">
                Angebot anfragen
              </button>
            </div>
          </form>
        </BasicModal>
        <BasicModal
            v-if="showConfirmation"
            class="md p-2 round"
            @close-modal="showConfirmation = false"
          >
          <template #icon>
            <BasicIcon :name="'xmark-solid'" class="w-4 close-img" />
          </template>
          <div class="p-4">
            <div class="text-xl">Ihre Anfrage wurde erfolgreich versendet</div>
          </div>
        </BasicModal>
      </teleport>
    </client-only>
  </div>
</template>
<script setup lang="ts">
import { withCdn } from '~~/shared/statics';

defineProps({
  entry: {
    type: Object,
    default: null,
  },
  design: {
    type: String,
    default: "",
  },
  linkText: {
    type: String,
    default: "",
  },
  linkPath: {
    type: String,
    default: "",
  }
});

const image = useCurrentStoreLogo(true);

const consent = ref(false);
const showForm = ref(false);
const currentStore = useCurrentStore();
const showConfirmation = ref(false);
const turnstile = ref();
const token = ref();
const captchaError = ref(false);
const uniqueEmailError = ref(false);
const showFullLegalText = ref(false);
async function validateForm(form: SubmitEvent) {
  captchaError.value = false;

  const formElement = form.target as HTMLFormElement | null;
  if (!formElement) {
    return;
  }

  const getInputValue = (selector: string): string => {

    const element = formElement.querySelector(selector);
    if (!(element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) {
      return "";
    }
    return element.value;
  };

  if (token.value) {
    const { status } = await useFetch("/_turnstile/validate", {
      body: {
        token: token.value,
      },
      method: "POST",
    });
    token.value = "";
    if (status.value == "success") {
      const formdata = {
        templateId: "d-f25c450348294f29b63223b12bd5af5f",
        transactional: false,
        categories: ["inquiry"],
        sender: "service@braintags.de",
        replyTo: "service@braintags.de",
        bcc: "expert-tk@braintags.de",
        recipient: currentStore.value?.email,
        templateData: {
          host: "https://www.expert.de",
          storeName: currentStore.value?.name,
          logo: withCdn(image.value),
          tarifID: getInputValue("#tarifId"),
          contactTime: getDateTimeFormated(
            parseDatetimeLocal(getInputValue("#validFrom"))
          ),
          contactAddress: {
            name: getInputValue("#name"),
            email: getInputValue("#email"),
            phone: getInputValue("#phone"),
          },
          message: getInputValue("#message"),
        },
        attachments: [],
      };
      console.debug("registering user for appointment");
      const csrfToken = useCurrentUserState().value?.csrfToken;
      const { error: tarifError } = await useFetch(
        "/api/neo/mail-render-service/sendDynamicEmail",
        {
          method: "POST",
          ...(csrfToken
            ? {
                headers: {
                  "csrf-token": csrfToken,
                },
              }
            : {}),
          body: formdata,
        }
      );

      if (tarifError.value) {
        console.error("failed to register an appointment", tarifError.value);
      } else {
        showForm.value = false;
        showConfirmation.value = true;
      }
    } else {
      captchaError.value = true;
      turnstile.value.reset();
    }
  } else {
    turnstile.value.reset();
  }
}

function parseDatetimeLocal(value: string): Date | null {
  if (!value) {
    return null;
  }

  const [datePart, timePart] = value.split("T");
  if (!datePart || !timePart) {
    return null;
  }

  const dateParts = datePart.split("-");
  const timeParts = timePart.split(":");

  if (dateParts.length !== 3 || timeParts.length < 2) {
    return null;
  }

  const year = Number(dateParts[0]);
  const month = Number(dateParts[1]);
  const day = Number(dateParts[2]);
  const hours = Number(timeParts[0]);
  const minutes = Number(timeParts[1]);

  if ([year, month, day, hours, minutes].some(Number.isNaN)) {
    return null;
  }

  return new Date(year, month - 1, day, hours, minutes);
}

function getDateFormated(date: Date | null): string {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return "";
  }

  const localString =
    String(date.getDate()).padStart(2, "0") +
    "." +
    String(date.getMonth() + 1).padStart(2, "0") +
    "." +
    date.getFullYear();
  return localString;
}

function getDateTimeFormated(date: Date | null): string {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return "";
  }

  const dateString = getDateFormated(date);
  const timeString =
    String(date.getHours()).padStart(2, "0") +
    ":" +
    String(date.getMinutes()).padStart(2, "0");

  return `${dateString} ${timeString}`;
}
</script>
<style scoped lang="postcss">
.title {
  @apply text-primary text-xl font-bold;
}
.date-range {
  @apply text-lg font-bold;
  & br {
    @apply hidden;
  }
}
.validFrom::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.short-description,
.legal-text {
  @apply whitespace-pre-line;
}
.id {
  @apply text-base font-bold;
}

.app {
  & .title {
    @apply text-base;
  }
  & .date-range {
    @apply text-sm;
    & br {
      @apply block;
    }
  }
  & .short-description {
    @apply text-sm;
  }
  & .id {
    @apply text-sm;
  }
  & .cta button {
    @apply w-full;
  }
}
</style>
